/* eslint-disable import/no-named-as-default */
import useFeatureSwitch from '../feature-switch.hook';

/** @returns {Boolean} */
export default function useWalletHelpLink() {
  const { data: link } = useFeatureSwitch('wallet_help_link');

  return link;
}
